import React from "react";
import {get, post} from '../../utils/api';
import './Functionality.css';
import FuncModal from '../Modal/Functionality';
import Loading from "../Shared/Loading";
import editIcon from "../../assets/edit-icon.svg";
import SVG from "react-inlinesvg";
import closeicon from "../../assets/close.svg";

class Functionality extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            functionalities: {},
            record: {},
            functionality: {},
            showModal: false,
            loading: true,
            action: false,
        };

        this.openModal = this.openModal.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.refreshFunctionality = this.refreshFunctionality.bind(this);
        this.setLoading = this.setLoading.bind(this);
        this.separateRichMedia= this.separateRichMedia.bind(this);
    }

    componentDidMount() {
       this.refreshFunctionality();
    };

    refreshFunctionality() {
        return get('manage/functionality')
            .then((res) => {
                this.separateRichMedia(res.result);
            })
    }

    openModal(record, functionality, action) {

        this.setState({
            record: record,
            functionality: functionality,
            action: action,
            showModal: true
        })
    }

    toggleModal(show) {

        this.setState({
            showModal: show
        })
    }

    setLoading(loading) {
        this.setState({
            loading: loading
        })
    }
    separateRichMedia(obj){
        let rich = []
        let name = ''
        let delName = ''
        Object.keys(obj).map((keyName, keyIndex) => {
            rich.push(keyName)
        })
        rich.map(k => {
            if(k.includes('Rich Media')){
                obj[k].map((record) => {
                    let arr = []
                    Object.entries(record).forEach(([key, value]) => {
                        if(key === 'functionalities'){
                            value.filter(f => {
                                if(f.name !== 'Expandable' && f.name !== 'Interstitial'){
                                    arr.push(f);
                                    record.functionalities = arr;
                                }
                            })
                        }
                    })
                    if(k === "Rich Media"){
                        name = k
                    }
                    if(k !== "Rich Media"){
                        obj[name].push(record)
                        delName = record.creative_type
                        delete obj[delName]
                    }
                })
            }
        })
        this.setState({
            functionalities: obj,
            loading: false
        })
    }

    render() {
        let editI = (<span className="f-edit"><SVG src={editIcon}/></span>);
        return (
            <div className="functionality-container">
                {this.state.showModal &&
                <FuncModal record={this.state.record}
                           action={this.state.action}
                           functionality={this.state.functionality}
                           functionalities={this.state.functionalities}
                           refreshFunctionality={this.refreshFunctionality}
                           setLoading={this.setLoading}
                           toggleModal={this.toggleModal}/>}
                {this.state.loading ? <Loading/> :
                    <div>
                        <h1 className="text-center">Functionality</h1>
                        {Object.keys(this.state.functionalities).map((keyName, keyIndex) => {
                            return (<div key={keyName} className="f-row">
                                {keyName.includes("Rich Media") ? '' : <h2>{keyName}</h2>}
                                {this.state.functionalities[keyName].map(record => (
                                    <div className="col" key={`creative-${record.creative_type_id}`}>
                                        {record.creative_type.includes("Rich Media") ? <h2>{record.creative_type}</h2> : ''}
                                        <h3 className={`f-unit-type f-unit-type-${record.unit_type}`}>{record.unit_type} <button className="f-button-create button button--grey button--small" onClick={() => this.openModal(record, {}, 'create')}>Create</button></h3>
                                        <table key={`${record.creative_type_id}-${record.unit_type}`} className="table-outline ">
                                            <tbody>
                                                {record.functionalities.map(item => (
                                                    <tr key={`${record.unit_type}-${item.id}`}><td
                                                        onClick={() => this.openModal(record, item, 'update')}>{item.name}       {editI}</td></tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ))}
                            </div>)
                        })}
                    </div>
                }
            </div>

        )
    }
}


export default Functionality;
